import React, {Component} from 'react'
import LocationEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class LocationEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {},
            userForm: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')

        const locationId = this.props.match.params.locationId
        AppContext.getApiClient().get('/locations/' + locationId).then(loc => {
            const userForm = <LocationEditForm location={loc} />
            this.setState({
                form: userForm
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default LocationEdit


// WEBPACK FOOTER //
// ./src/location/edit.component.jsx